import * as React from "react";
const ProfitsByAffiliates = (props) => (
  <svg
    width={34}
    height={33}
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_di_6515_2019)">
      <g clipPath="url(#clip0_6515_2019)">
        <rect x={1} width={32} height={32} rx={10} fill="#27272A" />
        <g clipPath="url(#clip1_6515_2019)" filter="url(#filter1_dd_6515_2019)">
          <path
            d="M17.8716 10.4671C18.7236 9.9103 20.2012 8.7063 20.2012 7.0399V6.3999H13.8012V7.0399C13.8012 8.7063 15.2788 9.9103 16.1308 10.4671C11.8396 11.1263 8.20117 16.5039 8.20117 20.7999C8.20117 23.4471 10.354 25.5999 13.0012 25.5999H21.0012C23.6484 25.5999 25.8012 23.4471 25.8012 20.7999C25.8012 16.5039 22.1628 11.1263 17.8716 10.4671ZM15.9156 17.4079L18.3492 17.8135C19.422 17.9919 20.2012 18.9119 20.2012 19.9999C20.2012 21.3231 19.1244 22.3999 17.8012 22.3999V23.1999H16.2012V22.3999C14.878 22.3999 13.8012 21.3231 13.8012 19.9999H15.4012C15.4012 20.4407 15.7604 20.7999 16.2012 20.7999H17.8012C18.242 20.7999 18.6012 20.4407 18.6012 19.9999C18.6012 19.6975 18.3844 19.4415 18.086 19.3919L15.6524 18.9863C14.5796 18.8079 13.8004 17.8879 13.8004 16.7999C13.8004 15.4767 14.8772 14.3999 16.2004 14.3999V13.5999H17.8004V14.3999C19.1236 14.3999 20.2004 15.4767 20.2004 16.7999H18.6004C18.6004 16.3591 18.2412 15.9999 17.8004 15.9999H16.2004C15.7596 15.9999 15.4004 16.3591 15.4004 16.7999C15.4004 17.1023 15.6172 17.3583 15.9156 17.4079Z"
            fill="url(#paint0_linear_6515_2019)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_6515_2019"
        x={0.5}
        y={0}
        width={33}
        height={33}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2019"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6515_2019"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={0.5} />
        <feGaussianBlur stdDeviation={0.25} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_6515_2019"
        />
      </filter>
      <filter
        id="filter1_dd_6515_2019"
        x={-22.5996}
        y={-19.7016}
        width={79.1992}
        height={79.2}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={10} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6515_2019"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3.89851} />
        <feGaussianBlur stdDeviation={15} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_6515_2019"
          result="effect2_dropShadow_6515_2019"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_6515_2019"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6515_2019"
        x1={8.06519}
        y1={2.45493}
        x2={22.4043}
        y2={21.7212}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="white" stopOpacity={0.65} />
      </linearGradient>
      <clipPath id="clip0_6515_2019">
        <rect x={1} width={32} height={32} rx={10} fill="white" />
      </clipPath>
      <clipPath id="clip1_6515_2019">
        <rect
          width={19.2}
          height={19.2}
          fill="white"
          transform="translate(7.40039 6.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ProfitsByAffiliates;
